import createReducer from 'redux/lib/reducerConfig';

const ActionTypes = {
  SET_MARKET_PRICE_SORTING: 'SET_MARKET_PRICE_SORTING',
};

export const setMarketPriceSorting = (sorting) => ({
  type: ActionTypes.SET_MARKET_PRICE_SORTING,
  payload: sorting,
});

export const sortingInitialState = {
  companyJobFamily: 'ASC',
  companyJobSubFamily: 'ASC',
  companyJobTitle: 'ASC',
};

export const sortingReducer = createReducer(
  sortingInitialState,
  {
    [ActionTypes.SET_MARKET_PRICE_SORTING]: (state, { payload }) => {
      return payload;
    },
  },
);
